export const ENV = import.meta.env.MODE;
export const API_URL = import.meta.env.VITE_API_URL;
export const CDN_URL = import.meta.env.VITE_CDN_URL;
export const MAP_KEY = import.meta.env.VITE_MAP_KEY;
export const SENTRY_AUTH_TOKEN = import.meta.env.VITE_SENTRY_AUTH_TOKEN;
